module.exports = __webpack_public_path__ + "img/header-engagementRingsEntwined.6b10732.jpg";